import React, { useState } from 'react';
import RoleBasedSidebar from '../../components/ui/RoleBasedSidebar';
import NavigationBreadcrumb from '../../components/ui/NavigationBreadcrumb';
import SearchTabs from './components/SearchTabs';
import OrderSummaryCard from './components/OrderSummaryCard';
import CustomerInfoCard from './components/CustomerInfoCard';
import PaymentForm from './components/PaymentForm';
import PaymentHistoryCard from './components/PaymentHistoryCard';
import DailyCashCloseCard from './components/DailyCashCloseCard';
import ActionButtons from './components/ActionButtons';

const Caja = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isMarking, setIsMarking] = useState(false);

  const mockOrders = [
    {
      id: 1,
      folio: "ORD-2026-001",
      date: "2026-02-15T08:00:00",
      status: "Lista",
      customer: {
        id: 1,
        name: "Carlos Rodríguez García",
        phone: "555-1234",
        email: "carlos.rodriguez@email.com"
      },
      vehicle: {
        brand: "Toyota",
        model: "Corolla",
        year: 2020,
        plates: "ABC-123",
        color: "Plata"
      },
      items: [
        {
          name: "Cambio de aceite sintético",
          quantity: 1,
          price: 850.00,
          total: 850.00
        },
        {
          name: "Filtro de aceite",
          quantity: 1,
          price: 250.00,
          total: 250.00
        },
        {
          name: "Rotación de llantas",
          quantity: 1,
          price: 400.00,
          total: 400.00
        }
      ],
      discount: 150.00,
      payments: [
        {
          amount: 500.00,
          method: "efectivo",
          date: "2026-02-15T09:30:00",
          change: 0
        }
      ]
    },
    {
      id: 2,
      folio: "ORD-2026-002",
      date: "2026-02-15T10:30:00",
      status: "En proceso",
      customer: {
        id: 2,
        name: "María Elena Fernández López",
        phone: "555-5678",
        email: "maria.fernandez@email.com"
      },
      vehicle: {
        brand: "Honda",
        model: "Civic",
        year: 2019,
        plates: "XYZ-789",
        color: "Negro"
      },
      items: [
        {
          name: "Juego de llantas 205/55R16",
          quantity: 4,
          price: 1200.00,
          total: 4800.00
        },
        {
          name: "Balanceo y montaje",
          quantity: 4,
          price: 150.00,
          total: 600.00
        },
        {
          name: "Alineación computarizada",
          quantity: 1,
          price: 450.00,
          total: 450.00
        }
      ],
      discount: 0,
      payments: []
    }
  ];

  const mockDailyData = {
    totalTransactions: 12,
    totalAmount: 18750.00,
    byMethod: [
      {
        name: "Efectivo",
        icon: "Banknote",
        count: 7,
        amount: 8500.00
      },
      {
        name: "Tarjeta",
        icon: "CreditCard",
        count: 4,
        amount: 7250.00
      },
      {
        name: "Transferencia",
        icon: "ArrowRightLeft",
        count: 1,
        amount: 3000.00
      }
    ]
  };

  const handleSearch = (searchType, searchValue) => {
    setIsSearching(true);
    
    setTimeout(() => {
      let foundOrder = null;
      
      if (searchType === 'phone') {
        foundOrder = mockOrders?.find(order => 
          order?.customer?.phone?.includes(searchValue)
        );
      } else if (searchType === 'plates') {
        foundOrder = mockOrders?.find(order => 
          order?.vehicle?.plates?.toLowerCase()?.includes(searchValue?.toLowerCase())
        );
      } else if (searchType === 'folio') {
        foundOrder = mockOrders?.find(order => 
          order?.folio?.toLowerCase()?.includes(searchValue?.toLowerCase())
        );
      }

      setSelectedOrder(foundOrder || null);
      setIsSearching(false);
    }, 800);
  };

  const calculateBalance = (order) => {
    if (!order) return 0;
    const subtotal = order?.items?.reduce((sum, item) => sum + item?.total, 0);
    const total = subtotal - (order?.discount || 0);
    const paid = order?.payments?.reduce((sum, p) => sum + p?.amount, 0) || 0;
    return total - paid;
  };

  const handlePayment = (paymentData) => {
    setIsProcessingPayment(true);
    
    setTimeout(() => {
      const newPayment = {
        ...paymentData,
        date: new Date()?.toISOString()
      };

      setSelectedOrder(prev => ({
        ...prev,
        payments: [...(prev?.payments || []), newPayment]
      }));

      setIsProcessingPayment(false);
      alert(`Pago procesado exitosamente\nMonto: $${paymentData?.amount?.toFixed(2)}\nMétodo: ${paymentData?.method}${paymentData?.change > 0 ? `\nCambio: $${paymentData?.change?.toFixed(2)}` : ''}`);
    }, 1000);
  };

  const handlePrintReceipt = () => {
    setIsPrinting(true);
    setTimeout(() => {
      setIsPrinting(false);
      alert('Ticket impreso correctamente');
    }, 1500);
  };

  const handleMarkDelivered = () => {
    setIsMarking(true);
    setTimeout(() => {
      setSelectedOrder(prev => ({
        ...prev,
        status: 'Entregada'
      }));
      setIsMarking(false);
      alert('Orden marcada como entregada\nInventario actualizado automáticamente');
    }, 1500);
  };

  const handleGenerateReport = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        alert('Reporte de cierre generado exitosamente');
        resolve();
      }, 1500);
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <RoleBasedSidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        userRole="caja"
      />
      <div
        className={`
          transition-all duration-250 ease-smooth
          ${isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-60'}
        `}
      >
        <div className="p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto">
          <NavigationBreadcrumb />

          <div className="mb-6 md:mb-8">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
              Caja
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Gestión de pagos y transacciones del día
            </p>
          </div>

          <div className="space-y-4 md:space-y-6">
            <SearchTabs onSearch={handleSearch} isSearching={isSearching} />

            {selectedOrder ? (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
                <div className="lg:col-span-2 space-y-4 md:space-y-6">
                  <OrderSummaryCard order={selectedOrder} />
                  
                  {selectedOrder?.payments && selectedOrder?.payments?.length > 0 && (
                    <PaymentHistoryCard payments={selectedOrder?.payments} />
                  )}

                  {calculateBalance(selectedOrder) > 0 && (
                    <PaymentForm
                      balance={calculateBalance(selectedOrder)}
                      onPayment={handlePayment}
                      isProcessing={isProcessingPayment}
                    />
                  )}
                </div>

                <div className="space-y-4 md:space-y-6">
                  <CustomerInfoCard
                    customer={selectedOrder?.customer}
                    vehicle={selectedOrder?.vehicle}
                  />
                  
                  <ActionButtons
                    order={selectedOrder}
                    onPrintReceipt={handlePrintReceipt}
                    onMarkDelivered={handleMarkDelivered}
                    isPrinting={isPrinting}
                    isMarking={isMarking}
                  />
                </div>
              </div>
            ) : (
              <div className="bg-card rounded-xl shadow-elevation-2 p-8 md:p-12 text-center">
                <div className="max-w-md mx-auto">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 md:w-10 md:h-10 text-muted-foreground"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
                    Buscar Orden
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    Utiliza el buscador para encontrar una orden por teléfono, placas o folio
                  </p>
                </div>
              </div>
            )}

            <DailyCashCloseCard
              dailyData={mockDailyData}
              onGenerateReport={handleGenerateReport}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Caja;